import { render, staticRenderFns } from "./type-de-demande.vue?vue&type=template&id=a9c4d4a8"
import script from "./type-de-demande.vue?vue&type=script&lang=js"
export * from "./type-de-demande.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports